import { render } from "./leaderboard.svg?vue&type=template&id=713318e2?inline"
const script = {}
script.render = render

export default script